import request from "@/libs/request";
import { CommonRequest, CommonResponse } from "@/types/common";
import {
  BidKeywordDetailResponse,
  BidRegionListResponse,
  FavoriteBidResponse,
  GetBidDetailResponse,
  GetBidFavoriteResponse,
  GetBidListResponse,
  GetBidPlanListResponse,
  GetBidSimilarDetailResponse,
  GetBidSimilarResponse,
  GetLiveSearchTextResponse,
} from "@/types/bid";

export const GetBidList = async (params?: CommonRequest) =>
  request.post<CommonResponse<GetBidListResponse>>(`/compute`, params);

export const GetBidDetail = async (projectId: string | undefined) =>
  request.post<CommonResponse<GetBidDetailResponse>>(`/compute`, {
    input: `project_id="${projectId}"\nproject.get_project_info(project_id)`,
  });

export const GetBidFavoriteList = async (params: string) =>
  request.post<CommonResponse<GetBidFavoriteResponse>>(`/compute`, {
    input: params,
  });

export const CreateFavoriteBid = async (
  project_type: string,
  project_id: string
) =>
  request.post<CommonResponse<FavoriteBidResponse>>(`/compute`, {
    input: `project_type="${project_type}"\nproject_id="${project_id}"\nbid.notice.star.mark(project_type, project_id)`,
  });

export const DeleteFavoriteBid = async (
  project_type: string,
  project_id: string
) =>
  request.post<CommonResponse<FavoriteBidResponse>>(`/compute`, {
    input: `project_type="${project_type}"\nproject_id="${project_id}"\nbid.notice.star.unmark(project_type, project_id)`,
  });

export const GetLiveTextSearch = async (method: string, query: string) =>
  request.post<CommonResponse<GetLiveSearchTextResponse>>(`/compute`, {
    input: `${method}(query="${query}")`,
  });

export const GetBidRegionList = async () =>
  request.post<CommonResponse<BidRegionListResponse>>(`/compute`, {
    input: "bid.notice.get_region_structure()",
  });

export const GetBidKeywordDetail = async (
  project_id: string | undefined,
  keywords: string[]
) =>
  request.post<CommonResponse<BidKeywordDetailResponse>>(`/compute`, {
    input:
      `project_ids=["${project_id}"]\n` +
      `keywords=${JSON.stringify(keywords)}\n` +
      `bid.notice.get_highlighted_documents(project_ids, keywords, highlight_tag_start=\'<span className="text-dark-red font-bold">\', highlight_tag_end=\'</span>\')`,
  });

export const GetBidPlanList = async (params?: CommonRequest) =>
  request.post<CommonResponse<GetBidPlanListResponse>>(`/compute`, params);

export const GetBidSimilarList = async (params?: string) =>
  request.post<CommonResponse<GetBidSimilarResponse>>(`/compute`, {
    input: `bid.notice.find_similar_project(\"${params}\")`,
  });

export const GetBidSimilarDetail = async (params?: string) =>
  request.post<CommonResponse<GetBidSimilarDetailResponse>>(`/compute`, {
    input: `bid.contract.get_contracts_detail(\"${params}\")`,
  });
